/**
 * Возвращает индекс следующего элемента.
 * Если строка полностью заполнена, возвращает индекс последнего элемента.
 */
export var getNextIndex = function getNextIndex(value, length) {
  var nextIndex = value.length;
  return nextIndex >= length ? nextIndex - 1 : nextIndex;
};